import React, { Component } from 'react'
import { Col, Container, Row } from '../../../../../Shared/Grid'
import Input from '../../../../../Shared/Form/Input'
import Button from '../../../../../Shared/Form/Button'
import isEmpty from 'lodash.isempty'

import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Alert from '../../../../../Shared/Alert'
import { EXPLOYEE_ORGANIZATIONS } from '../constants'
import Select from '../../../../../Shared/Form/Select'

const defaultEmployee = {
  organizationId: EXPLOYEE_ORGANIZATIONS.GIATA_INTERNAL.value,
  giataSalesId: '',
  employeeCode: '',
  email: ''
}

const PROPERTY_TRANSFORMER = {
  giataSalesId: (v) => parseInt(v, 10),
  organizationId: (v) => parseInt(v, 10)
}

class EmployeeForm extends Component {

  constructor (props) {
    super(props)

    this.state = {
      employee: Object.assign({}, defaultEmployee),
      errors: []
    }
    this.organizationOptions = Object.keys(EXPLOYEE_ORGANIZATIONS).map((key) => {
      return EXPLOYEE_ORGANIZATIONS[key]
    })
  }

  setEmployee (employee) {
    if (!employee) {
      this.setState({
        employee: Object.assign({}, defaultEmployee),
      })
      return
    }
    employee = Object.assign({}, employee)
    this.setState({ employee })
  }

  componentDidMount () {
    if (this.props.employee) {
      this.setEmployee(this.props.employee)
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.employee !== this.props.employee) {
      this.setEmployee(this.props.employee)
      this.isFormOk()
    }
  }

  updateEmployee (fieldName, value) {
    const employee = { ...this.state.employee }
    employee[fieldName] = value
    this.setState({ employee: employee })
  }

  handleSubmit (e) {
    e.preventDefault()
    if (this.isFormOk() === true) {
      let employee = Object.assign({}, this.state.employee)
      Object.keys(PROPERTY_TRANSFORMER).forEach((key) => {
        if (employee.hasOwnProperty(key)) {
          employee[key] = PROPERTY_TRANSFORMER[key](employee[key])
        }
      })
      this.props.onSave(employee)
    }
  }

  isFormOk () {
    const { t } = this.props
    const errors = {}
    const requiredFields = [
      'organizationId', 'giataSalesId', 'employeeCode', 'email'
    ]
    for (const requiredField of requiredFields) {
      if (
        this.state.employee[requiredField] === '' ||
        this.state.employee[requiredField] === null ||
        typeof this.state.employee[requiredField] === 'undefined'
      ) {
        errors[requiredField] = t('FORM_FIELD_IS_REQUIRED')
      }
    }
    if (this.state.employee.email !== '' && this.isEmailValid(this.state.employee.email) === false) {
      errors['email'] = t('FORM_FIELD_IS_INVALID')
    }
    this.setState({ errors: errors })
    return isEmpty(errors)
  }

  isEmailValid (email) {
    return /^[^@]+?@(?:[^@.]+\.)+[^@.]{2,}?$/.test(email)
  }

  render () {
    const { t } = this.props
    if (this.state.error) {
      return <Alert type={'danger'}>{this.state.error}</Alert>
    }

    return (
      <form onSubmit={(event) => this.handleSubmit(event)}>
        <Container fluid gutterWidth={5}>
          <Row>
            <Col xs={12} sm={6}>
              <Input value={this.state.employee.giataSalesId} label={t('EMPLOYEE_GIATA_SALES_ID')}
                     required={true}
                     valid={!this.state.errors.hasOwnProperty('giataSalesId')}
                     message={this.state.errors.giataSalesId ? this.state.errors.giataSalesId : ''}
                     onChange={(event) => this.updateEmployee('giataSalesId', event.target.value)}/>
            </Col>
            <Col xs={12} sm={6}>
              <Input value={this.state.employee.employeeCode} label={t('EMPLOYEE_EMPLOYEE_CODE')}
                     required={true}
                     valid={!this.state.errors.hasOwnProperty('employeeCode')}
                     message={this.state.errors.employeeCode ? this.state.errors.employeeCode : ''}
                     onChange={(event) => this.updateEmployee('employeeCode', event.target.value)}/>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <Input value={this.state.employee.email} label={t('EMAIL')}
                     required={true}
                     type={'email'}
                     valid={!this.state.errors.hasOwnProperty('email')}
                     message={this.state.errors.email ? this.state.errors.email : ''}
                     onChange={(event) => this.updateEmployee('email', event.target.value)}/>
            </Col>
            <Col xs={12} sm={6}>
              <Select onChange={(event) => this.updateEmployee('organizationId', event.target.value)}
                      options={this.organizationOptions}
                      label={t('EMPLOYEE_ORGANIZATION')}
                      valid={!this.state.errors.hasOwnProperty('organizationId')}
                      message={this.state.errors.organizationId ? this.state.errors.organizationId : ''}
                      selected={this.state.employee.organizationId}
                      required={true}
                      placeholder={''}/>
            </Col>
          </Row>
          <Row>
            <Col xs={6}> </Col>
            <Col xs={6}>
              <Button
                align={'right'}
                type={'submit'}>{this.props.saveLabel}</Button>
              {this.props.onCancel &&
              <Button
                align={'right'}
                classNames={'Button-Light'}
                onClick={this.props.onCancel}
                style={{ marginRight: '5px' }}>{this.props.cancelLabel}</Button>
              }
            </Col>
          </Row>
        </Container>
      </form>
    )
  }
}

EmployeeForm.defaultProps = {
  cancelLabel: 'Cancel'
}

EmployeeForm.propTypes = {
  employee: PropTypes.any,
  onSave: PropTypes.func.isRequired,
  saveLabel: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  cancelLabel: PropTypes.string
}

export default withTranslation()(EmployeeForm)
